import { Quaternion, Vector3, Matrix } from "@babylonjs/core/Maths/math.vector";
import { Observable } from '@babylonjs/core/Misc/observable';
import rgba from 'color-rgba';
import { Color4 } from "@babylonjs/core/Maths/math.color";
import { MeshType, Side, MeshSubType } from "../types";

export enum ColorSpace {
  rgba = "rgba",
  hsl = "hsl"
}

export class Math3D {
  public static QuaternionMultVector(q: Quaternion, v: Vector3): Vector3 {
    let target: Vector3 = Vector3.Zero();
    let x = v.x,
        y = v.y,
        z = v.z;

    let qx = q.x,
        qy = q.y,
        qz = q.z,
        qw = q.w;

    // q*v
    var ix =  qw * x + qy * z - qz * y,
    iy =  qw * y + qz * x - qx * z,
    iz =  qw * z + qx * y - qy * x,
    iw = -qx * x - qy * y - qz * z;

    target.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
    target.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
    target.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;

    return target;
  }

  public static LookAt(eye: Vector3, target: Vector3, up: Vector3) {
    let m = Matrix.LookAtRH(eye, target, up);
    m.invert();
    return Quaternion.FromRotationMatrix(m)
  }

}

export const observeOnceToPromise = async <T>(success: Observable<T>) => {
  return await new Promise<void>((resolve) => {
    success.addOnce(() => resolve());
  })
}

export const parseColor = (color: string): Color4 => {
  const data = rgba(color);
  return new Color4(data[0] / 255, data[1] / 255, data[2] / 255, data[3]);
}

export const meshKey = (mesh: MeshType, sub: MeshSubType, side: Side) => `${mesh}${sub?"."+sub:""}.${side}`
